class CommentsController {
    constructor(Util, Report, growl, $state, $uibModal) {
        "ngInject";
        let vm = this;
        vm.comments = [];
        vm.reportFilter = "all"; // mostra commenti e segnalazioni insieme
        vm.$onInit = start;
        vm.addNote = addNote;
        vm.markAsRead = markAsRead;
        vm.markAsUnread = markAsUnread;
        vm.saveNote = saveNote;
        vm.goToResource = goToResource;
        vm.next = next;
        vm.prev = prev;
        vm.viewImages = viewImages;
        vm.pagination = {
            page: 0,
            offset: 25
        };
        vm.newNotes = [];
        vm.showNewNotes = [];
        vm.changeReportFilter = start;
        vm.viewReportMap = viewReportMap;

        function start() {
            vm.pagination.page = 0;
            init();
        }

        function init() {
            vm.newNotes = [];
            vm.showNewNotes = [];

            Report.getList(vm.pagination.page, vm.pagination.offset, vm.reportFilter).then(res => {
                vm.comments = res.data;
            })
        }

        function addNote(report, reportIndex) {
            // console.log("Add note", report);
            vm.showNewNotes[reportIndex] = true;
        }

        function saveNote(report, reportIndex) {
            if (!vm.newNotes[reportIndex]) {
                vm.showNewNotes[reportIndex] = false;
                return false;
            }
            let adminComment = {
                comment: vm.newNotes[reportIndex],
                createdDate: new Date(),
                report: {id: report.id}
            };
            Report.postAdminComment(adminComment).then(res => {
                init();
                vm.newNotes[reportIndex] = "";
                vm.showNewNotes[reportIndex] = true; // continua a mostrare i commenti
                growl.success("Nota interna aggiunta correttamente");
            }, err => {
                growl.error("Error salvataggio nota interna");
            })
        }

        function markAsRead(report, reportIndex) {
            let callback = function () {
                growl.success("Segnalazione segnata come letta");
                report.reportStatus = "READ";
            }
            changeReportStatus(report, callback);
        }

        function markAsUnread(report, reportIndex) {
            let callback = function (rep) {
                growl.success("Segnalazione segnata come non letta");
                rep.reportStatus = "UNREAD";
            }
            changeReportStatus(report, callback);
        }

        function changeReportStatus(report, callback) {
            let reportCopy = angular.copy(report);
            Report.put(reportCopy).then(res => {
                callback(report);
            }, err => {
                growl.error("Errore cambio stato segnalazione");
            })
        }

        function goToResource(report) {
            $state.go("dashboard.detail.description", {
                id: report.modelId,
                modelType: report.modelEnum,
                modelName: report.modelEnum
            })
        }

        function next() {
            if (vm.comments.length < vm.pagination.offset) {
                return;
            }
            vm.pagination.page++;
            init();
        }

        function prev() {
            if (vm.pagination.page === 0) {
                return;
            }
            vm.pagination.page--;
            init();
        }

        function viewImages(report, reportIndex) {
            return $uibModal.open({
                component: 'reportImages',
                size: 'lg',
                resolve: {
                    images: () => report.images
                }
            })
        }

        function viewReportMap(report, reportIndex) {
            return $uibModal.open({
                component: 'reportMap',
                size: 'lg',
                resolve: {
                    report: () => report
                }
            })
        }
    }
}

export default CommentsController;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/comments/comments.controller.js